export default "__VITE_ASSET__DhHiTHT$__"